import { createSlice } from '@reduxjs/toolkit';
import { ShipmentConfirmQCState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { shipmentConfirmQCThunk } from './thunks';

// Initial State
const initialState: ShipmentConfirmQCState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const shipmentConfirmQCSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    resetShipmentConfirmQC: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(shipmentConfirmQCThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(shipmentConfirmQCThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
      state.values = null;
    });
    builder.addCase(shipmentConfirmQCThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { resetShipmentConfirmQC } = shipmentConfirmQCSlice.actions;
export * from './thunks';
export default shipmentConfirmQCSlice.reducer;
